import { useExportResourceToGoogleMutation } from '../resourcesApi';
import {
  GOOGLE_WORKSPACE_EXPORT_SCOPES,
  formatGoogleWorkspaceError,
  withGoogleWorkspaceScopes,
} from '../services/googleWorkspaceService';

import type { Resource } from '@/shared/types/resource';

interface UseGoogleDocsExportOptions {
  onError?: (message: string | null) => void;
}

export function useGoogleDocsExport(options: UseGoogleDocsExportOptions = {}) {
  const [exportResourceToGoogle] = useExportResourceToGoogleMutation();

  const exportToGoogle = async (resource: Pick<Resource, 'id' | 'resourceKind'>) => {
    options.onError?.(null);
    const exportLabel = resource.resourceKind === 'slide' ? 'Google Slides' : 'Google Docs';

    try {
      const result = await withGoogleWorkspaceScopes(GOOGLE_WORKSPACE_EXPORT_SCOPES, () =>
        exportResourceToGoogle({
          resourceId: resource.id,
          resourceKind: resource.resourceKind,
        }).unwrap()
      );

      const popup = window.open(result.url, '_blank');
      if (!popup) {
        window.location.assign(result.url);
        return;
      }

      popup.opener = null;
    } catch (error) {
      options.onError?.(formatGoogleWorkspaceError(error, `Failed to export to ${exportLabel}.`));
    }
  };

  return { exportToGoogle };
}
